import type {
    LegalEntityBranchData,
    LegalEntityBranchCreateParams,
    LegalEntityBranchUpdateParams,
    LegalEntityBranchListQuery,
    LegalEntityBranchListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/legal-entity-branch';

export class LegalEntityBranchApi {
    public static async getList(params?: LegalEntityBranchListQuery): Promise<LegalEntityBranchData[]> {
        const res = await axios.get<LegalEntityBranchListResponse>(BASE_URL, { params });

        return res.data.legalEntityBranches;
    }

    public static async create(legalEntityBranch: LegalEntityBranchCreateParams): Promise<void> {
        await axios.post(BASE_URL, { legalEntityBranch });
    }

    public static async update(id: string, legalEntityBranch: LegalEntityBranchUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { legalEntityBranch });
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}

export { BASE_URL as LEGAL_ENTITY_BRANCH_BASE_URL };
